module.exports = __webpack_public_path__ + "img/vip-bg-1248.e6a5a382.png";